import Api from "@/helpers/api.js";

import {
  getListForm,
  createForm,
  createPage,
  createDependence,
  createContador,
  getForm,
  getCounter,
  getAllPages,
  getDependencies
} from "@/serviforms/designer/indexDB/logic.js";

import store from "@/store";
import messages from "@/serviforms/designer/helpers/messgeError";

export default {
  async runApp({ commit, state, dispatch }, FormID) {
    const formID = FormID ? FormID : null;
    const { companyID, uuid } = store.state.user;
    const listForms = await getListForm({ company: companyID, uuid: uuid });

    if (listForms.length === 0) {
      await dispatch("createForm");
    } else if (listForms.length === 1) {
      const idForm = formID !== null ? formID : listForms[0].key;
      await dispatch("recreateForm", idForm);
    } else {
      if (formID !== null) await dispatch("recreateForm", formID);
      else {
        const { key } = listForms.filter(form => form.active)[0];
        await dispatch("recreateForm", key);
      }
    }
    dispatch("getCreatedDependencies");
  },
  async createForm({ commit, state }) {
    const { companyID, uuid } = store.state.user;
    const data = {
      method: "create",
      companyId: companyID,
      name: "",
      groupId: "",
      uuid: uuid,
      version: 1,
      formType: "0",
      active: true
    };

    const keyForm = await createForm(data);

    const page = {
      id_form: keyForm,
      questions: []
    };

    const id_page = await createPage(page);

    const dependencias = {
      id_form: keyForm,
      simple: {},
      dependencias: [],
      listener: {},
      compound: {},
      columns: {}
    };

    const id_dependencia = await createDependence(dependencias);

    const contador = {
      id_form: keyForm,
      contador: 0
      // contador: store.state.resource.counter
    };
    const id_contador = await createContador(contador);

    commit("UPDATE_STATE", { key: "idForm", value: keyForm });
    commit("UPDATE_STATE", { key: "idPage", value: id_page });
    commit("UPDATE_STATE", { key: "idCounter", value: id_contador });
    commit("UPDATE_STATE", { key: "idDependency", value: id_dependencia });
    commit("UPDATE_STATE", { key: "idDependence", value: id_dependencia });
    commit("UPDATE_STATE", { key: "disabledGroup", value: false });
    return keyForm;
  },
  async recreateForm({ commit, state }, keyForm) {
    const resultado = await getForm(keyForm);
    const { method, groupId, name, version, formType, key: formID, companyId: companyID  } = await getForm(keyForm);

    const isUpdate = method === "update" ? true : false;
    commit("CHANGE_DATA_SIDEBAR", { nameForm: name, grupo: groupId, version, isSubForm: formType, formID: formID, companyID });
    commit("UPDATE_STATE", { key: "idForm", value: keyForm });
    commit("UPDATE_STATE", { key: "disabledGroup", value: isUpdate });

    const counter = await getCounter();
    commit("UPDATE_STATE", { key: "idCounter", value: counter.key });
    commit("UPDATE_STATE", { key: "counter", value: counter.contador });

    const allPages = await getAllPages();
    const { key, questions } = allPages[0];

    commit("UPDATE_STATE", { key: "idPage", value: key });
    commit("UPDATE_STATE", { key: "questionsByPage", value: questions });
    commit("UPDATE_STATE", { key: "allPages", value: allPages });

    const objectDependence = await getDependencies();
    commit("UPDATE_STATE", { key: "idDependence", value: objectDependence.key });
  },
  async getApi({ commit, state }, payload) {
    try {
      const reult = await Api.get(payload);
      return reult.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getOrigins({ commit, state }) {
    try {
      const result = await Api.get("/origins");
      const mapeo = result.data
        .filter(origin => origin.columns !== null)
        .map(origin => {
          return {
            key: origin.key,
            description: origin.description,
            columns: origin.columns,
            totalRecords: origin.totalRecords
          };
        });
      commit("UPDATE_STATE", { key: "listOrigins", value: mapeo });
    } catch (e) {
      // statements
      console.log(e);
    } finally {
      // statements
    }
  },
  async getSubformularios({ commit, state }) {
    try {
      const result = await Api.get("/subforms");
      const mapeo = result.data.map(form => {
        return {
          value: form.key,
          text: form.activity
        };
      });
      commit("UPDATE_STATE", { key: "listSubFormularios", value: mapeo });
    } catch (e) {
      // statements
      console.log(e);
    } finally {
      // statements
    }
  },
  async getOneSubformDetails({ commit, state }, id) {
    try {
      const result = await Api.get(`/forms/${id}/last`);
      const { dependencies } = result.data.form;
      delete result.data.form.dependencies;
      return result.data;
    } catch (e) {
      // statements
      console.log(e);
    } finally {
      // statements
    }
  },
  async saveFormAction({ commit, state }, form) {
    try {
      const reult = await Api.post("/forms", form);
      return reult.data;
    } catch (error) {
      console.log("saveFormAction -1 ", error);
      const {
        data: { reason }
      } = error;
      if (messages[reason]) throw new Error(messages[reason]);
      return error;
    }
  },
  async updateFormAction({ commit, state }, { form, key }) {
    try {
      const reult = await Api.put(`/forms/${key}`, form);
      return reult.data;
    } catch (error) {
      console.log("saveFormAction ", error);
      throw new Error(error);
    }
  },
  async validator({ state }, { form, type }) {
    try {
      const data = {
        schema: type,
        data: form
      };
      return await Api.post("/validator", data);

    } catch (error) {
      const elements = error.error[0].absolute_path.map(item => isNaN(item) ? `['${item}']`: `[${item}]`).join('');
      const joinElments = `form${elements}`;
      const valueEnd = eval(joinElments);

      throw {
        type: 'validate',
        msg: `"${valueEnd}" es un valor inválido dentro de la estructura del formulario (API).`
      }
    }
  },
  async getCreatedDependencies({ commit, state }) {
    const { simple } = await getDependencies();
    commit("UPDATE_STATE", { key: "saveCreatedDependecies", value: simple });
  }
};
